import React from 'react';

function Intro() {
  return (
    <div className="intro-card section-padding" data-scroll-index="0">
      <div className="caption">
        <span className="mb-30 fw-200 fz-22">Hello, I&apos;m</span>
        <h2 className="text-u ls1 mb-40">
          Matthew <span className="botm d-block">Perry</span>
        </h2>
        <span className="mb-30 fw-200 fz-22">Industry Certified</span>
        <h2 className="text-u ls1">
          Graphic <span className="botm d-block">Designer</span>
        </h2>
      </div>
    </div>
  );
}

export default Intro;
